import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Account, AccountItem } from 'src/app/models';

@Injectable({
  providedIn: 'root',
})
export class AccountHttpService {
  readonly http = inject(HttpClient);

  public createAccount(account) {
    return this.http.post<Account>('/create_accounts', account);
  }

  // TODO - To be DELETED (not used)
  public createAccountItem(accountItem) {
    return this.http.post<Account>('/account_items', accountItem);
  }

  public getAccounts(showDeadStatus) {
    return this.http.get<Account[]>(`/accounts/${showDeadStatus}`);
  }

  // TODO - To be DELETED (not used)
  public getAccountsPaginated(page, payload) {
    return this.http.post(`/accounts_paginated?page=${page}`, payload);
  }

  public getAccountsByActionFilter(actionFilter) {
    return this.http.post<Account[]>('/accounts_action_filter', actionFilter);
  }

  public getAccount(id) {
    return this.http.get<Account>(`/account/${id}`);
  }

  public getAccountItemsByAccount(id) {
    return this.http.get<AccountItem[]>(`/account_items_by_account/${id}`);
  }

  // TODO - To be DELETED (not used)
  public updateAccountItemStatus(id, statusId) {
    return this.http.get(`/account_item_status_update/${id}/${statusId}`);
  }

  // TODO - To be DELETED (not used)
  public updateAccountItem(id, quoteItem, qty, statusId, coefficient) {
    return this.http.get(
      `/account_item_update/${id}/${quoteItem}/${qty}/${statusId}/${coefficient}`
    );
  }

  public updateAccountStatus(id, due_date, project_status, financial_status) {
    return this.http.put(
      `/account_update_status/${id}/${due_date}/${project_status}/${financial_status}`,
      ''
    );
  }

  public updateAccountDueDate(id, due_date) {
    return this.http.put(`/account_update_due_date/${id}/${due_date}`, '');
  }

  public updateAccountFinancialStatus(id, financialStatus) {
    return this.http.put(
      `/account_update_financial_status/${id}/${financialStatus}`,
      ''
    );
  }

  // TODO - To be DELETED (not used)
  public getAccountsByCustomer(id) {
    return this.http.get<Account[]>(`/accounts_by_customer/${id}`);
  }

  public updateAccountManagedBy(id, user) {
    return this.http.put(`/account_update_managed_by/${id}/${user}`, '');
  }
}
